// Extracts the video ID from any common YouTube URL shape, or passes through
// a bare 11-char ID. The embed URL is always built here (youtube-nocookie.com,
// no autoplay/related-videos) rather than trusting a stored raw URL/iframe src —
// this is also how we keep the page from ever showing a plain youtube.com link.
export function extractYouTubeId(input) {
  const value = (input || '').trim();
  if (!value) return null;
  if (/^[\w-]{11}$/.test(value)) return value;
  const patterns = [
    /(?:youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/,
    /youtu\.be\/([\w-]{11})/,
  ];
  for (const pattern of patterns) {
    const match = value.match(pattern);
    if (match) return match[1];
  }
  return null;
}

export function youtubeEmbedUrl(input) {
  const id = extractYouTubeId(input);
  if (!id) return null;
  return `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1`;
}
